import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { clearAllNotifications } from '../../actions/notifications';
import Button from '../Basic/Button';

const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    '& button': {
      width: '100%',
      color: 'var(--color-clear-notification-color)',
      border: '1px solid #f85b67',
      backgroundColor: 'var(--color-clear-notification-bg)',
      height: 38,

      '&:hover': {
        backgroundColor: 'var(--color-clear-notification-bg)',
      },
    },
  },
}));

const ClearNotifications = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(clearAllNotifications());
  };

  return (
    <div className={`${classes.root} clear-notifications-btn`}>
      <Button onClick={handleClick} variant="contained" color="white">
        Clear All
      </Button>
    </div>
  );
};

export default ClearNotifications;
